<template>
    <span style="width: 10px; text-align: left;" v-html="dots"></span>
</template>
<script setup>
import {ref} from "vue";

let dots = ref('.');
setInterval(function() {
    dots.value = '.'.repeat(dots.value.length === 3 ? 1 : dots.value.length + 1);
}, 300);
</script>
